<template>
  <div class="content">
    <img class="msp" v-lazy="require('../../assets/imgs/msp_back.png')" />
    <el-row class="one">
      <el-col :span="24" class="title">
        <img v-lazy="require('../../assets/imgs/msp_title1.png')" />
      </el-col>
      <el-col :span="2">&nbsp;</el-col>
      <el-col :span="5" class="left">
        <div>
          <img />
          <p>
            &nbsp;
          </p>
        </div>
        <div>
          <span>阅读作业</span>
          <p>
            支持在线完成阅读作业，作业分为书籍阅读、短篇阅读、朗读三种类型，系统根据学生作业答案实时生成作业报告。
          </p>
          <img v-lazy="require('../../assets/imgs/line1.png')" class="line line1" />
        </div>
        <div>
          <span>朗读</span>
          <p>
            支持用户自主选择朗读素材进行朗读，朗读素材包含散文、诗歌、古诗词、中小学朗读素材、国学经典、经典文学等分类，且部分素材支持试听领读。
          </p>
          <img v-lazy="require('../../assets/imgs/line2.png')" class="line line2" />
        </div>
      </el-col>
      <el-col :span="1">&nbsp;</el-col>
      <el-col :span="8">
        <img v-lazy="require('../../assets/imgs/msp1.png')" width="100%" />
      </el-col>
      <el-col :span="5" class="right">
        <div>
          <span>语音识别</span>
          <p>
            分级阅读平台所有文字输入框都支持实时语音转写（Real-time ASR）基于深度全序列卷积神经网络框架，通过 WebSocket 协议，建立应用与语言转写核心引擎的长连接，将音频流数据实时转换成文字流数据结果。
          </p>
          <img v-lazy="require('../../assets/imgs/line3.png')" class="line line3" />
        </div>
        <div>
          <span>阅读时长</span>
          <p>
            用户可通过最近七天阅读时长折线图快速直观掌握最近七天每天的阅读时长，且可以查看详细阅读记录：阅读量、阅读书籍数量、阅读时长、阅读足迹等阅读数据。
          </p>
          <img v-lazy="require('../../assets/imgs/line4.png')" class="line line4" />
        </div>
        <div style="height:15vh;position: relative;top:-5vh">
          <span>阅读记录</span>
          <p>
            记录阅读进度、笔记等阅读行为，可快速跳转至最后阅读位置以及文字批注位置。
          </p>
          <img v-lazy="require('../../assets/imgs/line5.png')" class="line line5" />
        </div>
      </el-col>
      <el-col :span="2">&nbsp;</el-col>
      <el-col :span="24" class="bottem">
        <el-row class="msp_description">
          <el-col :span="4">&nbsp;</el-col>
          <el-col :span="6" class="detail">
            <span>实时了解学生阅读情况</span>
            <p>
              实时查看学生的阅读能力测评报告、阅读数据，更加了解学生的阅读能力，优化教学方案。
            </p>
            <span>随时发布作业、公告</span>
            <p>
              教师能布置阅读、朗读作业以及发布阅读素材，并实时查看学生的作业结果；
              支持编辑文本公告，随时通知学生。
            </p>
          </el-col>
          <el-col :span="2">&nbsp;</el-col>
          <el-col :span="10" class="detailimg">
            <img v-lazy="require('../../assets/imgs/msp2.png')" />
          </el-col>
          <el-col :span="2">&nbsp;</el-col>
        </el-row>
      </el-col>
    </el-row>
    <el-row class="two">
      <el-col :span="24" class="title">
        <img v-lazy="require('../../assets/imgs/msp_title2.png')" />
      </el-col>
      <el-col :span="2">&nbsp;</el-col>
      <el-col :span="6" class="left">
        <div>
          <img v-lazy="require('../../assets/imgs/jhg_detail1.png')" class="jhg_detail" />
        </div>
        <div>
          <img v-lazy="require('../../assets/imgs/jhg_detail3.png')" class="jhg_detail" />
        </div>
      </el-col>
      <el-col :span="8">
        <img v-lazy="require('../../assets/imgs/jhg1.png')" width="100%" />
      </el-col>
      <el-col :span="6" class="right">
        <div>
          <img v-lazy="require('../../assets/imgs/jhg_detail2.png')" class="jhg_detail" />
        </div>
        <div>
          <img v-lazy="require('../../assets/imgs/jhg_detail4.png')" class="jhg_detail" />
        </div>
      </el-col>
      <el-col :span="2">&nbsp;</el-col>
    </el-row>
    <!-- <el-row class="three">
      <el-col :span="24" class="title">
        <img v-lazy="require('../../assets/imgs/msp_title3.png')" />
      </el-col>
      <el-col :span="2">&nbsp;</el-col>
      <el-col :span="20">
        <div class="block">
          <img v-lazy="require('../../assets/imgs/swiperback1.png')" class="swiperback" />
          <el-carousel trigger="click" :loop="true" height="900px" indicator-position="outside">
            <el-carousel-item>
              <img v-lazy="require('../../assets/imgs/jhg3.png')" />
              <p class="name">墨水屏借还柜</p>
              <p class="type">32口</p>
            </el-carousel-item>
            <el-carousel-item>
              <img v-lazy="require('../../assets/imgs/jhg4.png')" />
              <p class="name">墨水屏借还柜</p>
              <p class="type">32口</p>
            </el-carousel-item>
            <el-carousel-item>
              <img v-lazy="require('../../assets/imgs/jhg6.png')" />
              <p class="name">墨水屏借还柜</p>
              <p class="type">64口</p>
            </el-carousel-item>
            <el-carousel-item>
              <img v-lazy="require('../../assets/imgs/jhg5.png')" />
              <p class="name">墨水屏借还柜</p>
              <p class="type">64口</p>
            </el-carousel-item>
          </el-carousel>
        </div>
      </el-col>
      <el-col :span="2">&nbsp;</el-col>
    </el-row> -->
    <el-row class="four">
      <el-col :span="24" class="title">
        <img v-lazy="require('../../assets/imgs/msp_title4.png')" />
      </el-col>
      <el-col :span="4">&nbsp;</el-col>
      <el-col :span="16">
        <el-table stripe id="table" style="width: 100%" :data="tableData">
          <el-table-column prop="name" label="" style="width:50%">
          </el-table-column>
          <el-table-column prop="data" label="" style="width:50%">
          </el-table-column>
        </el-table>
      </el-col>
      <el-col :span="4">&nbsp;</el-col>
    </el-row>
    <el-row class="five">
      <el-col :span="24" class="title">
        <img v-lazy="require('../../assets/imgs/msp_title5.png')" />
      </el-col>
      <el-col :span="2">&nbsp;</el-col>
      <el-col :span="20">
        <div>
          <el-carousel type="card" trigger="click" :loop="true" height="500px" indicator-position="outside">
            <el-carousel-item>
              <img v-lazy="require('../../assets/imgs/Reading_room2.png')" />
            </el-carousel-item>
            <el-carousel-item>
              <img v-lazy="require('../../assets/imgs/The_classroom.png')" />
            </el-carousel-item>
            <el-carousel-item>
              <img v-lazy="require('../../assets/imgs/The_library1.png')" />
            </el-carousel-item>
          </el-carousel>
        </div>
      </el-col>
      <el-col :span="2">&nbsp;</el-col>
    </el-row>
  </div>
</template>
<script>
export default {
  name: "pcMsp",
  data () {
    return {
      msg: "这是PC的墨水屏宣传页",
      tableData: [
        { name: "操作系统：", data: "Android 8.1" },
        { name: "产品尺寸：", data: "7.8寸/10.3寸" },
        { name: "分辨率：", data: "1404x1872" },
        { name: "触控类型：", data: "电容触控" },
        { name: "数据接口：", data: "Type-C" },
        { name: "无线连接：", data: "WIFI(5G/2.4G)、蓝牙" },
        { name: "固件升级：", data: "支持本地升级/OTA升级" },
        { name: "操作温度：", data: "0°C- 50°C" },
        { name: "语言：", data: "支持多国语言" },
        { name: "处理器：", data: "Quad-core 1.6G Hz/PX30" },
        { name: "刷新模式：", data: "A2快刷、局刷、全刷可选" }
      ]
    };
  }
};
</script>

<style scoped>
.msp {
  position: relative;
  top: -27vh;
  left: -9.5vw;
}
.title {
  margin-bottom: 8vh;
  margin-top: 10vh;
}
.left p,
.right p {
  text-align: left;
  color: #999999;
}
.left div,
.right div {
  margin-bottom: 5vh;
}
.left span,
.right span {
  display: inline-block;
  margin-bottom: 2vh;
  font-size: 30px;
  font-weight: bolder;
  color: #890101;
}
.left div {
  text-align: right;
}
.right div {
  text-align: left;
}
.left {
  margin-top: 5vh;
}
.line {
  position: relative;
  z-index: 999;
}
.line1 {
  left: 0.5vw;
  top: -5vh;
}
.line2 {
  left: -1.2vw;
  top: -28.5vh;
}
.line3 {
  right: 12vw;
  top: -3vh;
}
.line4 {
  float: left;
  right: 12vw;
  top: -15vh;
}
.line5 {
  float: left;
  right: 16.5vw;
  top: -30vh;
}
.msp_description {
  height: 100vh;
  background-image: url("../../assets/imgs/swiperback.png");
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  text-align: left;
}
.detail {
  margin-top: 25vh;
}
.detailimg {
  margin-top: 20vh;
}
.msp_description span {
  display: inline-block;
  background-color: #e7dac3;
  border-radius: 20px;
  height: 5vh;
  line-height: 5vh;
  width: 60%;
  font-size: 24px;
  text-align: center;
  margin-bottom: 2vh;
}
.msp_description p {
  margin-bottom: 2vh;
  text-align: left;
  font-size: 24px;
  color: #999999;
}

.jhg_detail {
  width: 31vw;
  position: relative;
  z-index: 999;
}
.two .left .jhg_detail {
  margin-bottom: 23.5vh;
  margin-top: 0vh;
}
.two .right {
  position: relative;
  margin-top: 10.5vh;
  right: 8.8vw;
}
.three {
  background-image: url("../../assets/imgs/swiperback.png");
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
}
.swiperback {
  float: right;
  position: absolute;
  left: 40vw;
  top: 24vh;
}
.block .name {
  font-size: 30px;
  font-weight: bolder;
}
.block .type {
  font-size: 25px;
  font-weight: bolder;
  color: #890101;
}
</style>



// WEBPACK FOOTER //
// src/components/pc/msp.vue